import {HERO_BANNER} from '../constants';

const initialState = {loy3HeroBanner: null}

export const home = (state = initialState, action) => {
  switch (action.type) {
    case HERO_BANNER:
      return {
        ...state,
        loy3HeroBanner: action.payload
      };
    default:
      return state;
  }
}
